import { useParams, Link } from "react-router-dom";
import { PRODUCT_NAME } from "@/config";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";
import { PublicFooter } from "@/components/PublicFooter";
import { MiniMarkdown } from "@/components/MiniMarkdown";
import { MENTIONS_MD } from "@/content/mentionsLegales";

const CONTENT = {
  cgu: {
    title: "CGU / CGV",
    body: [
      [`Objet`, `Les présentes conditions régissent l'accès et l'utilisation de ${PRODUCT_NAME}. La version définitive et opposable sera publiée avant l'ouverture commerciale.`],
      [`Abonnement & essai`, `L'essai gratuit est sans carte bancaire. À son terme, le compte passe en lecture seule sans suppression de données. L'abonnement est résiliable en libre-service.`],
      [`Publication LinkedIn`, `La publication s'effectue via l'API officielle LinkedIn, sur autorisation explicite de l'utilisateur, pour ses propres contenus.`],
    ],
  },
};

function Mentions() {
  useEffect(() => {
    const prev = document.title;
    document.title = `Mentions légales | ${PRODUCT_NAME}`;
    return () => { document.title = prev; };
  }, []);
  return <div data-testid="mentions-content"><MiniMarkdown source={MENTIONS_MD} /></div>;
}

function Body({ c }) {
  return (
    <>
      <h1 className="font-serif text-4xl font-bold mb-8">{c.title}</h1>
      <div className="space-y-6">
        {c.body.map(([h, t], i) => (
          <div key={i}>
            <h2 className="font-bold text-ink mb-1">{h}</h2>
            <p className="text-slate-600 leading-relaxed text-sm">{t}</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-slate-400 mt-12">Document indicatif, version définitive publiée avant l'ouverture commerciale.</p>
    </>
  );
}

export default function Legal({ type: propType }) {
  const { type } = useParams();
  const key = propType || type;
  return (
    <>
    <div className="min-h-screen bg-[#FBFAF8] text-ink font-sans">
      <div className="max-w-2xl mx-auto px-6 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-coral-dark mb-8"><ArrowLeft className="h-4 w-4" /> Retour à l'accueil</Link>
        {CONTENT[key] ? <Body c={CONTENT[key]} /> : <Mentions />}
      </div>
    </div>
    <PublicFooter />
    </>
  );
}
